import type { MbcBriefPatch } from "@nlc/shared-types";

import { MBC_MASTRA_API_URL } from "../config/mbc-chat.config";

/**
 * Persist a partial brief edit to the working memory (live save). Reuses the
 * review page's PATCH route: top-level fields are shallow-merged; array fields
 * (e.g. `variations`) are replaced wholesale, so send the full array.
 */
export async function patchBrief(
  threadId: string,
  resourceId: string | undefined,
  patch: MbcBriefPatch,
): Promise<void> {
  const query = resourceId
    ? `?resourceId=${encodeURIComponent(resourceId)}`
    : "";

  const response = await fetch(
    `${MBC_MASTRA_API_URL}/mbc/brief/${encodeURIComponent(threadId)}${query}`,
    {
      body: JSON.stringify(patch),
      headers: { "Content-Type": "application/json" },
      method: "PATCH",
    },
  );

  if (!response.ok) throw new Error(`HTTP ${response.status}`);
}
